import React from "react";
import { connect } from 'react-redux';
import _ from 'lodash';
import { format, getDate, addDays, setMinutes, setSeconds, startOfWeek, differenceInCalendarISOWeeks, setMilliseconds, setDay, parse } from 'date-fns'
import { Actions as ACTIONS } from '../../../store/actions/leaveActions';
import BreakdownDay from "./BreakdownDay";

const LeaveBreakdown = ({
    weekStartsOn,
    modalLeave,
    days,
    type
}) => {
    const today = setMinutes(setSeconds(setMilliseconds(new Date(), 0), 0), 0);
    const { date, dateTo, weeklyBreakdown } = modalLeave

    const fromDate = date && parse(date, 'yyyy-MM-dd', new Date()) || today
    const toDate = dateTo && parse(dateTo, 'yyyy-MM-dd', new Date()) || today

    const firstDay = startOfWeek(fromDate, { weekStartsOn })
    const lastWeekStartDate = startOfWeek(toDate, { weekStartsOn })
    const weeks = differenceInCalendarISOWeeks(lastWeekStartDate, firstDay) > 53 ? 52 : differenceInCalendarISOWeeks(lastWeekStartDate, firstDay)
    const arrayWeeks = (type == 'week' && Array.isArray(weeklyBreakdown)) ? weeklyBreakdown : [...Array(weeks + 1)]

    if (dateTo === date) return null
    if (!date || !dateTo) return null

    if (type === "week") {
        const weeksPerRow = 7
        const weekRows = Math.ceil(Math.max(arrayWeeks?.length, 1) / weeksPerRow)
        const arrayWeekRows = [...Array(weekRows)]
        return (
            <div className="col-xs-12 leavedays" style={{ textAlign: "center" }}>
                <h6 style={{ textAlign: 'left' }}>Weekly Breakdown</h6>
                <div style={{ display: 'grid', gridTemplateColumns: `repeat(${weeksPerRow}, minmax(0, 1fr))`, gridTemplateRows: `repeat(${weekRows}, minmax(0, 1fr))`, gap: '0.5rem' }}>
                    {arrayWeekRows?.map((a, weekDivider) => {
                        const start = weekDivider * weeksPerRow
                        const end = (weekDivider + 1) * weeksPerRow
                        return (<>
                            {arrayWeeks?.slice(start, end)?.map((a, weekNo) => {
                                weekNo = weekNo + (weekDivider * weeksPerRow)
                                const dateFrom = addDays(firstDay, weekNo * 7)
                                const dateTo = addDays(firstDay, (weekNo * 7) + 6)
                                const [dayFrom, dayTo] = [format(dateFrom, 'do'), format(dateTo, 'do')]
                                const [monthFrom, monthTo] = [format(dateFrom, 'MMM'), format(dateTo, 'MMM')]
                                return (
                                    <div key={`arrayWeek-${weekNo}`} style={{ fontWeight: "bold", display: 'grid', fontSize: 11, height: "100%", margin: 0 }}>
                                        <div>{monthFrom}{monthFrom !== monthTo ? `-${monthTo}` : null}</div>
                                        <div>{dayFrom}-{dayTo}</div>
                                        {/* <div>{weekNo + 1}</div> */}
                                        <BreakdownDay day={0} weekNo={weekNo} blockType={'week'} />
                                    </div>
                                )
                            })}
                        </>)
                    })}
                </div>
            </div>
        )
    }

    // for each week we need a row
    return (
        <div className="col-xs-12 pl-0 leavedays" style={{ textAlign: "center", marginBottom: 20, width: "auto" }}>
            <table>
                <thead>
                    <tr style={{ fontWeight: "bold" }}>
                        <th style={{ textAlign: "left" }}>Weekday</th>
                        {days?.map((day) => {
                            const dateToUse = format(setDay(new Date(), day + weekStartsOn), 'eeeeee')
                            return <th key={`weekday-${day}`}>{dateToUse}</th>
                        })}
                    </tr>
                </thead>

                <tbody>
                    {arrayWeeks?.map((a, weekNo) => (
                        <>
                            <tr key={`month-tr-${weekNo}`}>
                                <th />
                                {days?.map(day => {
                                    const dateToUse = addDays(firstDay, day + weekNo * 7)
                                    const dayOfMonth = getDate(dateToUse);
                                    const showMonth = dayOfMonth == 1 || (day == 0 && weekNo == 0)
                                    return (
                                        <th key={`day-month-${format(dateToUse, 'dd-MMM')}`} style={{ fontWeight: "bold", fontSize: 11, height: 16 }}>{showMonth ? format(dateToUse, 'MMM') : ''}</th>
                                    )
                                })}
                            </tr>

                            <tr key={`day-tr-${weekNo}`}>
                                <th style={{ textAlign: "left" }}>Day</th>
                                {days?.map(day => (
                                    <th key={`day-week-${day}-${weekNo}`}>{getDate(addDays(firstDay, day + weekNo * 7))}</th>
                                ))}
                            </tr>
                            <tr key={`hours-tr-${weekNo}`}>
                                <td style={{ textAlign: "left" }}>Hours</td>
                                {days?.map(day => <BreakdownDay day={day} weekNo={weekNo} />)}
                            </tr>
                        </>

                    ))}

                </tbody>
            </table>
            <div className="clearfix" />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        jurisdiction: state.company?.settings?.jurisdiction,
        weekStartsOn: state.company?.settings?.jurisdiction == "UK" ? 0 : 1,
        modalLeave: state.leave.modalLeave || {},
        modalStatus: state.leave?.modalStatus?.status || {},
        currentAgreement: state?.leave?.modalStatus?.employee || {},
        days: state.leave?.days || [0, 1, 2, 3, 4, 5, 6],
    }
}

const mapDispatchToProps = dispatch => ({
    updateBreakdown: ({ dateToUseString, hours, remove }) => dispatch(ACTIONS.updateBreakdown({ dateToUseString, hours, remove })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeaveBreakdown)
